import { TranslatedValueDTO } from '../core/translated-value-dto';
import { ResearchSubEntityDTO } from '../core/subentities/research-sub-entity-dto';

export interface CvSectionConfigDTO extends ResearchSubEntityDTO {
    type: string;
    name: TranslatedValueDTO;
    order: number;
    entryType?: string;
    active: boolean;
    primaryFilter?: string[];
    secondaryFilter?: string[];
    excludeHidden?: boolean;
    format?: string;
    expanded?: boolean;
}

export abstract class CvSectionConfigClass implements CvSectionConfigDTO {
    type: string;
    id: string;
    name: TranslatedValueDTO;
    order: number;
    entryType: string;
    active: boolean;
    primaryFilter: string[];
    secondaryFilter: string[];
    excludeHidden: boolean;
    format: string = null;
    expanded?: boolean;

    constructor(section?: CvSectionConfigDTO) {
        // Object.assign(this, section);
    }
}
